import process from 'process';
import React from 'react';
import { buildTargetingArguments } from '../../common/helpers/ads/AdsHelper';
import AdSlot from './AdSlot';
import { AdsCardWrapper } from './CardsAds.style';
import { AnalyticsProject } from '../../common/analytics/interfaces/analyticsProject';

interface CardsAdsProps {
  adUnit?: string;
  sect?: string | string[];
  subSect?: string;
  project?: AnalyticsProject;
  articleId?: string | number | null;
}

const CardsAds: React.FC<CardsAdsProps> = ({
  adUnit = '',
  sect = [''],
  subSect = '',
  project = {},
  articleId = null,
}) => {
  const targetingArguments = buildTargetingArguments(project);

  return (
    <AdsCardWrapper className="ad-card">
      {(process.browser || process.env.browser) && (
        <AdSlot
          adUnit={adUnit}
          sizes={[[300, 250]]}
          targetingArguments={{
            ...targetingArguments,
            sect,
            subSect,
            lang: 'th',
            articleid: articleId,
          }}
        />
      )}
    </AdsCardWrapper>
  );
};

export default CardsAds;
